function isExternal(href) {
  return href.startsWith("http");
}

export function ActionLink({ href, children, secondary = false }) {
  return (
    <a
      className={`button${secondary ? " button-secondary" : ""}`}
      href={href}
      rel={isExternal(href) ? "noreferrer" : undefined}
      target={isExternal(href) ? "_blank" : undefined}
    >
      {children}
    </a>
  );
}
